// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Pg_2_1_avatarContainer__vo7+2"};